import { render } from "./AlienPlayerScoutSummaryReportView.vue?vue&type=template&id=ec81b72e"
import script from "./AlienPlayerScoutSummaryReportView.vue?vue&type=script&lang=js"
export * from "./AlienPlayerScoutSummaryReportView.vue?vue&type=script&lang=js"

import "./AlienPlayerScoutSummaryReportView.vue?vue&type=style&index=0&id=ec81b72e&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__